import { render } from "./personalexcellence.vue?vue&type=template&id=3a01b319"
import script from "./personalexcellence.vue?vue&type=script&lang=js"
export * from "./personalexcellence.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__